import React from "react";

export default function RequiredSpan() {
    return <span style={{color:"red"}}>*</span>
}